
import ApiManager from "./ApiManager";
import { AppCache } from "./myStorage";
import config from "../config";
import { CryptoJSAesEncrypt } from "./cryp.js";

const helpUrl = config().HELP_URL;
const partnerUrl = config().PARTNER_URL;

export default class PartnerApi extends ApiManager {

  static async getlicenseDocList(params = {}) {
    try {
      const url = new URL(config().HELP_URL + "/licenseDocList");
      url.searchParams.append("licenseNo", params.licenseNo);
      url.searchParams.append("language", params.language || "tr");

      const signature = CryptoJSAesEncrypt(params.licenseNo);

      const response = await fetch(url.toString(), {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "application-code": config().CODE,
          signature,
        },
      });

      if (!response.ok) {
        throw new Error("API hatası: " + response.status);
      }

      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      console.error("getlicenseDocList error:", error);
      return null;
    }
  }

  static async getlicenseDocInfo(params = {}) {
    debugger;
    try {
      if (!params.licenseNo) throw new Error("licenseNo required for licenseDocInfo");

      const language = params.language || "tr";

      const url = new URL(`${config().HELP_URL}/licenseDocInfo`);
      url.searchParams.append("licenseNo", params.licenseNo);

      if (params.helpPath) {
        url.searchParams.append("helpPath", params.helpPath);
      }

      url.searchParams.append("language", language);

      const signature = CryptoJSAesEncrypt(
        params.licenseNo + (params.helpPath || "")
      );

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "application-code": config().CODE,
          signature,
        },
      });

      if (!response.ok) {
        throw new Error(`API hatası: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("getlicenseDocInfo error:", error);
      return null;
    }
  }


}


